module.exports = __webpack_public_path__ + "images/avatars/female/3.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/3.svg
// module id = DFGL
// module chunks = 118